"use client";

import { Phone, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StartYourTransformation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="133855" id="ready-for-the-bathers-glow" className="relative py-24 md:py-32 overflow-hidden dark bg-background text-foreground">
            {}
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-primary/20 via-background to-background bg-cover bg-center bg-fixed opacity-60 mix-blend-screen" aria-hidden="true" style={{
      backgroundImage: 'url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1593773/img/car_wireframe_blueprint.png)'
    }} />

            {}
            <div ref={ref} className={`relative z-10 container mx-auto px-4 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
                <h2 className="text-5xl md:text-6xl lg:text-7xl font-serif font-extrabold text-foreground mb-10 max-w-4xl leading-none tracking-widest uppercase drop-shadow-2xl">
                    BRING THE GLOSS HOME
                </h2>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto">
                    <Button asChild size="lg" className="w-full sm:w-auto rounded-sm bg-secondary text-secondary-foreground hover:bg-secondary/90 text-lg h-14 px-10 shadow-2xl transition-all hover:scale-105 font-mono uppercase tracking-wider">
                        
                    </Button>

                    <Button asChild size="lg" variant="outline" className="w-full sm:w-auto rounded-sm border-2 border-primary text-primary hover:bg-primary/10 text-lg h-14 px-10 bg-transparent shadow-xl transition-all hover:scale-105 font-mono uppercase tracking-wider">
                        <Link to="/GetInTouchPage">
                            Request Quote
                        </Link>
                    </Button>
                </div>
            </div>
        </section>;
}